import { css } from '@linaria/core';
import { icon } from '../icon/icon.styles';
import theme from '../../../theme';

export const variants = {
  outlined: css``,
  primary: css``,
  secondary: css``,
  tertiary: css``,
  borderless: css``,
  square: css``,
  toggle: css``,
  small: css``,
  active: css``,
  onlyChild: css``,
};

const iconClass = `.${icon}`;

export const button = css`
  display: inline-flex;
  --btn-height: var(--control-height, 36px);
  gap: 8px;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  line-height: 24px;
  font-weight: 700;
  border-width: 0px;
  border-style: solid;
  border-radius: 24px;
  border-color: transparent;
  height: var(--btn-height);
  padding: 0.5em 1.5em;
  box-shadow: ${theme.elevation.peoople};
  font-size: 16px;

  @media screen and (width > ${theme.sizes.screens.md}) {
    font-size: 20px;
  }

  &.${variants.square} {
    border-radius: 12px;
  }

  &:hover&:not([disabled]) {
    box-shadow: ${theme.elevation.base};
  }

  &:active {
  }

  &[disabled] {
    background: ${theme.colors.neutral['40']};
    color: ${theme.colors.neutral['0']};
    border-color: transparent;
    cursor: not-allowed;
  }

  &${`.${variants.onlyChild}`}:has(${iconClass}:only-child) {
    padding: 6px;
    font-size: 18px;
    height: 36px;
    width: 36px;
  }

  &.${variants.primary} {
    background: ${theme.colors.primary['60']};
    color: white;
    border-color: transparent;
    &:hover {
      background: white;
      color: ${theme.colors.peoople['azul-claro-medio']};
    }

    &:active {
      background: ${theme.colors.peoople['gris-oscuro-2']};
      color: white;
    }

    &[disabled] {
      color: #ffffff;
      background: ${theme.colors.neutral['30']};
    }
  }

  &.${variants.borderless} {
    background: white;
    color: ${theme.colors.peoople['gris-oscuro']};
    border-color: transparent;
    box-shadow: ${theme.elevation.peoople};
    &:hover {
      color: white;
      background: ${theme.colors.peoople['azul-claro-medio']};
    }

    &:active {
      background: ${theme.colors.peoople['gris-oscuro-2']};
      color: white;
    }

    &[disabled] {
      color: #ffffff;
      background: ${theme.colors.neutral['30']};
    }
  }

  &.${variants.toggle} {
    border-color: #000000;
    font-weight: 600;
    color: ${theme.colors.peoople['gris-oscuro']};
    border-width: 2px;
    background-color: white;
    font-size: 0.8em;
    &:hover,
    &.${variants.active} {
      background-color: ${theme.colors.peoople['gris-oscuro']};
      color: white;
    }
    @media screen and (width > ${theme.sizes.screens.md}) {
      font-size: 1em;
    }
  }

  &.${variants.secondary} {
    background: white;
    color: ${theme.colors.neutral[1]};
    border-color: ${theme.colors.neutral['70']};
    &:hover {
    }

    &:active {
      background: ${theme.colors.peoople['gris-oscuro-2']};
      color: white;
    }

    &[disabled] {
      background: ${theme.colors.neutral['20']};
    }
  }

  &.${variants.tertiary} {
    background: rgba(0, 0, 0, 0.3);
    color: ${theme.colors.white};
    &:hover {
      background: rgba(0, 0, 0, 0.6);
      color: ${theme.colors.peoople['gris-claro']};
    }

    &:active {
      background: rgba(0, 0, 0, 0.4);
      color: ${theme.colors.peoople['gris-medio']};
    }

    &[disabled] {
      color: ${theme.colors.neutral['30']};
      background: transparent;
    }
  }

  &.${variants.outlined} {
    color: var(--button-active);
    border-color: var(--button-active);
    background-color: transparent;
    &[disabled] {
      background: transparent;
      color: ${theme.colors.neutral['40']};
      border-color: ${theme.colors.neutral['20']};
    }
  }
  &.${variants.small} {
    height: 30px;
    font-size: 11px;
    font-weight: 600;
    &${`.${variants.onlyChild}`}:has(${iconClass}:only-child) {
      padding: 4px;
      width: 24px;
      height: 24px;
      font-size: 12px;
    }
  }
`;
